<template>
  <div
    class="lista-tavolo layout-panoramica-side-panel navy darken-2"
    :class="{ collapsed }"
  >
    <div v-if="!collapsed" class="lista-tavolo-content">
      <div
        class="titolo navy--text text--lighten-2 font-hemi-head"
      >
        <span>Partecipanti</span>
        <div class="lista-tavolo-actions">
          <v-menu offset-y left content-class="section-options-menu-content">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                rounded
                depressed
                class="section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2"
                title="Opzioni lista"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon x-small>tune</v-icon>
              </v-btn>
            </template>
            <v-list dense dark class="section-options-menu navy darken-1">
              <v-subheader class="section-options-menu-title">
                Mostra
              </v-subheader>
              <v-list-item
                v-for="option in displayOptions"
                :key="option.key"
                dense
                @click="toggleDisplayOption(option.key)"
              >
                <v-list-item-action>
                  <v-checkbox
                    dense
                    hide-details
                    readonly
                    :input-value="displayPrefs[option.key]"
                    color="secondary"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ option.label }}</v-list-item-title>
                  <v-list-item-subtitle v-if="option.description">
                    <span
                      v-for="line in option.description"
                      :key="line"
                      class="d-block"
                    >
                      {{ line }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y left content-class="section-options-menu-content">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                rounded
                depressed
                class="section-title-action-btn lista-tavolo-sort-btn navy darken-3 navy--text text--lighten-3 px-2"
                :title="`Ordina: ${currentSortOption.label}`"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon x-small class="mr-1">fa-sort</v-icon>
                <v-icon x-small>{{ currentSortOption.icon }}</v-icon>
              </v-btn>
            </template>
            <v-list dense dark class="section-options-menu navy darken-1">
              <v-subheader class="section-options-menu-title">
                Ordina per
              </v-subheader>
              <v-list-item
                v-for="option in sortOptions"
                :key="option.value"
                dense
                :class="{
                  'lista-tavolo-menu-item--selected':
                    sortBy == option.value,
                }"
                @click="sortBy = option.value"
              >
                <v-list-item-icon>
                  <v-icon x-small>{{ option.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ option.label }}</v-list-item-title>
                <v-list-item-action v-if="option.value == SORT_TAVOLO">
                  <v-btn
                    icon
                    x-small
                    title="Modifica ordine tavolo"
                    @click.stop="showAstaOrder"
                  >
                    <v-icon x-small>edit</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
      <div class="lista-tavolo-list nice-scroll">
        <squadra-tavolo
          v-for="squadraItem in sortedSquadre"
          :key="squadraItem.id"
          :id="squadraItem.id"
          class="lista-tavolo-partecipante"
          variant="line"
          :menu-context="Constants.SQUADRA_TAVOLO_MENU_CONTEXT.PANORAMICA"
          :show-line-crediti="displayPrefs.crediti"
          :show-line-max-offerta="displayPrefs.maxOfferta"
          :show-line-max-offerta-bar="displayPrefs.maxOffertaBar"
          :line-max-offerta-ratio="squadraItem.maxOffertaRatio"
        ></squadra-tavolo>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vuex from "vuex";
import Constants from "../../js/constants";
import db from "../../js/db";
import mixins from "../../js/mixins";
import SquadraTavolo from "./SquadraTavolo";

const LS_LISTA_TAVOLO_PREFS = "lista_tavolo_prefs";
const SORT_TAVOLO = "tavolo";
const SORT_MAX_OFFERTA = "maxOfferta";
const SORT_CREDITI = "crediti";
const SORT_ALFABETICO = "alfabetico";

const defaultPrefs = {
  display: {
    crediti: true,
    maxOfferta: true,
    maxOffertaBar: true,
  },
  sortBy: SORT_TAVOLO,
};

function getStoredPrefs() {
  const storedPrefs = localStorage.getItem(LS_LISTA_TAVOLO_PREFS);
  if (!storedPrefs) {
    return defaultPrefs;
  }

  try {
    const parsedPrefs = JSON.parse(storedPrefs);
    const parsedDisplay = parsedPrefs.display || {};
    return {
      ...defaultPrefs,
      ...parsedPrefs,
      display: {
        crediti:
          "crediti" in parsedDisplay
            ? parsedDisplay.crediti
            : defaultPrefs.display.crediti,
        maxOfferta:
          "maxOfferta" in parsedDisplay
            ? parsedDisplay.maxOfferta
            : defaultPrefs.display.maxOfferta,
        maxOffertaBar:
          "maxOffertaBar" in parsedDisplay
            ? parsedDisplay.maxOffertaBar
            : defaultPrefs.display.maxOffertaBar,
      },
    };
  } catch (e) {
    return defaultPrefs;
  }
}

export default {
  name: "lista-tavolo",
  mixins: [mixins],
  components: {
    SquadraTavolo,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const storedPrefs = getStoredPrefs();
    return {
      displayPrefs: { ...storedPrefs.display },
      sortBy: storedPrefs.sortBy,
      SORT_TAVOLO,
    };
  },
  watch: {
    displayPrefs: {
      deep: true,
      handler() {
        this.savePrefs();
      },
    },
    sortBy() {
      this.savePrefs();
    },
  },
  computed: {
    Constants() {
      return Constants;
    },
    displayOptions() {
      return [
        {
          key: "crediti",
          label: "Crediti residui",
          description: ["Numero assoluto di crediti ancora disponibili."],
        },
        {
          key: "maxOfferta",
          label: "Offerta massima",
          description: ["Massimo rilancio possibile della squadra."],
        },
        {
          key: "maxOffertaBar",
          label: "Barra offerta massima",
          description: [
            "PS: La luncghezza della barra è relativa rispetto agli altri partecipanti.",
          ],
        },
      ];
    },
    sortOptions() {
      return [
        {
          value: SORT_TAVOLO,
          label: "Ordine tavolo",
          icon: "settings_backup_restore",
        },
        {
          value: SORT_MAX_OFFERTA,
          label: "Offerta massima",
          icon: "trending_up",
        },
        {
          value: SORT_CREDITI,
          label: "Crediti residui",
          icon: "paid",
        },
        {
          value: SORT_ALFABETICO,
          label: "Alfabetico",
          icon: "sort_by_alpha",
        },
      ];
    },
    currentSortOption() {
      return (
        this.sortOptions.find((option) => option.value == this.sortBy) ||
        this.sortOptions[0]
      );
    },
    maxOffertaReference() {
      return Math.max(
        ...this.squadreForList.map((squadra) => squadra.maxOfferta),
        0
      );
    },
    squadreForList() {
      return this.asta_squadre_array.map((squadraItem) => {
        const squadra = this.asta_squadre[squadraItem.id] || {};
        const crediti = parseFloat(squadra.crediti) || 0;
        const maxOfferta = parseFloat(squadra.max_offerta) || 0;

        return {
          ...squadraItem,
          crediti,
          maxOfferta,
          name: squadraItem.name || squadra.name || "",
          order: squadraItem.order || 0,
        };
      });
    },
    sortedSquadre() {
      return _.orderBy(
        this.squadreForList.map((squadra) => ({
          ...squadra,
          maxOffertaRatio: this.ratio(
            squadra.maxOfferta,
            this.maxOffertaReference
          ),
        })),
        this.sortIteratees,
        this.sortOrders
      );
    },
    sortIteratees() {
      if (this.sortBy == SORT_MAX_OFFERTA) {
        return [
          (squadra) => squadra.maxOfferta,
          (squadra) => squadra.order,
        ];
      }

      if (this.sortBy == SORT_CREDITI) {
        return [
          (squadra) => squadra.crediti,
          (squadra) => squadra.order,
        ];
      }

      if (this.sortBy == SORT_ALFABETICO) {
        return [
          (squadra) => squadra.name.toLowerCase(),
          (squadra) => squadra.order,
        ];
      }

      return [(squadra) => squadra.order];
    },
    sortOrders() {
      if (this.sortBy == SORT_MAX_OFFERTA || this.sortBy == SORT_CREDITI) {
        return ["desc", "asc"];
      }

      if (this.sortBy == SORT_ALFABETICO) {
        return ["asc", "asc"];
      }

      return ["asc"];
    },
    ...Vuex.mapGetters(["asta_squadre", "asta_squadre_array"]),
  },
  methods: {
    ratio(value, reference) {
      if (!reference) {
        return 0;
      }

      return Math.max(0, Math.min(100, (value * 100) / reference));
    },
    savePrefs() {
      localStorage.setItem(
        LS_LISTA_TAVOLO_PREFS,
        JSON.stringify({
          display: this.displayPrefs,
          sortBy: this.sortBy,
        })
      );
    },
    toggleDisplayOption(key) {
      this.displayPrefs = {
        ...this.displayPrefs,
        [key]: !this.displayPrefs[key],
      };
    },
    showAstaOrder() {
      if (this.isAstaInCorso) {
        db.emit("swalAstaInCorso");
        return;
      }
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.emit("showAstaOrder");
    },
  },
};
</script>

<style lang="scss" scoped>
.lista-tavolo.layout-panoramica-side-panel {
  flex: 0 0 200px;
  min-width: 0;
  overflow: hidden;
  transition: flex-basis 0.18s ease;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.lista-tavolo.layout-panoramica-side-panel.collapsed {
  flex-basis: 0;
}

.lista-tavolo-content {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.lista-tavolo-actions {
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  gap: 4px;
}

.lista-tavolo-sort-btn {
  min-width: 42px !important;
}

.lista-tavolo-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-left: 5px;
  gap: 2px;
}

.lista-tavolo-partecipante {
  flex: 0 0 auto;
}

</style>
